<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="remarkTitle" :subheading="subheading" />
    <div style="display: flex;margin: 20px 0;">
      <el-button class="btn-add" icon="el-icon-plus" @click="remarkAdd" v-if="permissionCodes.indexOf('016007002') !== -1">添加</el-button>
    </div>
    <table-main
      :selection="false"
      :tableHead="tableHeadRemark"
      :tableData="tableDataRemark"
      :operationArr="operationArr"
      :tableHeight="420"
      :deleteTipInfo="'是否确认删除该条数据？'"
      @deleteLine="deleteLine"
      :total="totalRemark"
      :pageNum="pageNumRemark"
      :pageSize="pageSizeRemark"
      @changePagination="changePaginationRemark"
    />
    <text-title :mainTitle="valueTitle" :subheading="subheading" />
    <div style="display: flex;margin: 20px 0;">
      <el-button class="btn-add" icon="el-icon-plus" @click="valueAdd" v-if="permissionCodes.indexOf('016007001') !== -1">添加</el-button>
    </div>
    <table-main
      :selection="false"
      :hasOperation="false"
      :tableHead="tableHeadValue"
      :tableData="tableDataValue"
      :tableHeight="420"
      :total="totalValue"
      :pageNum="pageNumValue"
      :pageSize="pageSizeValue"
      @changePagination="changePaginationValue"
    />
    <value-dialog
      ref="valueRef"
      :dialogValue="dialogValue"
      @valueConfirm="valueConfirm"
      @valueCancel="valueCancel">
    </value-dialog>
    <remark-dialog
      ref="remarkRef"
      :dialogRemark="dialogRemark"
      :copyList="copyList"
      @remarkConfirm="remarkConfirm"
      @remarkCancel="remarkCancel">
    </remark-dialog>
  </div>
</template>

<script>
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
import TextTitle from '../../../components/Text/TextTitle'
import ButtonConfirm from '../../../components/Button/ButtonConfirm'
import ButtonCancel from '../../../components/Button/ButtonCancel'
import TableMain from "../../../components/Table/TableMain";
import {bus} from '../../../utils/bus'
import {api} from '../../api/invoice'
import {nError, nSuccess, nWarn} from '../../../utils/notice'
import {errorHandler} from '../../../utils/errorHandler'
import Clipboard from "clipboard";
import valueDialog from './valueDialog';
import remarkDialog from './remarkDialog';

export default {
  components: {
    ButtonCancel,
    ButtonConfirm,
    TextTitle,
    Breadcrumb,
    TableMain,
    valueDialog,
    remarkDialog
  },
  name: 'contract-add',
  data () {
    return {
      breadcrumb: [
        {value: '智慧凭证', name: 'invoice-over-view'},
        {value: "备注管理"}
      ],
      valueTitle: '可选取值',
      remarkTitle: '备注列表',
      subheading: '',
      formDataValue: {
        type: '自定义取值',
        name: '',
        value: ''
      },
      formDataRemark: {
        name: '',
      },
      tableHeadValue: [
        {
          prop: 'typeText',
          label: '类型',
        },
        {
          prop: 'name',
          label: '名称',
        },
        {
          prop: 'value',
          label: '取值',
        },
      ],
      tableDataValue: [],
      tableHeadRemark: [
        {
          prop: 'name',
          label: '名称',
        },
        {
          prop: 'dynamicText',
          label: '文本',
        },
      ],
      tableDataRemark: [
      ],
      dialogValue: false,
      dialogRemark: false,
      permissionCodes: [],
      operationArr: ['delete'],
      pageNumValue: 1,
      pageSizeValue: 10,
      totalValue: 0,
      pageNumRemark: 1,
      pageSizeRemark: 10,
      totalRemark: 0,
      copyList: [],
    }
  },
  created () {
    this.permissionCodes = bus.global.permissionCodes;
    this.getValueList();
    this.getRemarkList();
    this.getCopyValueList();
  },
  methods: {
    // 获取取值
    getValueList() {
      this.$axios
        .post(api.getValueList, {pageNum: this.pageNumValue,pageSize: this.pageSizeValue})
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            if (data.list && data.list.length > 0) {
              this.tableDataValue = data.list.map(item =>{
                if (item.type == '0') {
                  item.typeText = '系统取值';
                } else if (item.type == '1') {
                  item.typeText = '自定义取值';
                }
                return item;
              })
              console.log(this.tableDataValue, 'data')
            } else {
              this.tableDataValue = [];
            }
            this.totalValue = data.total;
            console.log(this.totalValue, 'total')
          }
        })
        .catch(errorHandler("获取取值列表失败"));
    },

    // 获取备注
    getRemarkList () {
      this.$axios
        .post(api.getRemarkList, {pageNum: this.pageNumRemark,pageSize: this.pageSizeRemark})
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            this.tableDataRemark = data.list;
            this.totalRemark = data.total;
          }
        })
        .catch(errorHandler("获取备注列表失败"));
    },

    // 获取可复制取值
    getCopyValueList () {
      this.$axios
        .post(api.getCopyValueList, {searchKey: ''})
        .then(res => {
          if (res.data.retCode === 1) {
            let copyList = res.data.data;
            if (copyList && copyList.length > 0) {
              this.copyList = copyList.map(item=>{
                item.name = `&{${item.name}}`;
                return item
              })
            } else {
              this.copyList = [];
            }
          }
        })
        .catch(errorHandler("获取可复制取值列表失败"));
    },

    // 取值保存
    valueConfirm (data) {
      this.formDataValue.name = data.name;
      this.formDataValue.value = data.value;
      if (!this.formDataValue.name) {
        nError('请输入名称');
        return;
      }
      if (!this.formDataValue.value) {
        nError('请输入取值');
        return false;
      }
      this.$axios.post(api.addValue, this.formDataValue)
        .then(res => {
          nSuccess('保存成功');
          this.dialogValue = false;
          this.pageNumValue = 1;
          this.pageSizeValue = 10;
          this.getValueList();
          this.getCopyValueList();
        })
        .catch(errorHandler('保存失败'))
    },

    // 备注保存
    remarkConfirm (data) {
      this.formDataRemark.name = data.name;
      this.formDataRemark.dynamicText = data.dynamicText;
      console.log(this.formDataRemark.dynamicText, 'text')
      if (!this.formDataRemark.name) {
        nError('请输入名称');
        return;
      } else if (!this.formDataRemark.dynamicText) {
        nError('请输入文本');
        return;
      }
      this.$axios.post(api.addRemark, this.formDataRemark)
        .then(res => {
          nSuccess('保存成功');
          this.dialogRemark = false;
          this.pageNumRemark = 1;
          this.pageSizeRemark = 10;
          this.getRemarkList();
        })
        .catch(errorHandler('保存失败'))
    },

    // 取值弹框取消
    valueCancel() {
      this.dialogValue = false;
      this.formDataValue.name = '';
      this.formDataValue.value = '';
      // this.getValueList();
    },

    // 备注弹框取消
    remarkCancel() {
      this.dialogRemark = false;
      this.formDataRemark.name = '';
      // this.getRemarkList();
    },

    // 添加取值
    valueAdd() {
      this.$refs.valueRef.formDataValue.name = '';
      this.$refs.valueRef.formDataValue.value = '';
      this.dialogValue = true;
    },

    // 添加备注
    remarkAdd() {
      this.$refs.remarkRef.formDataRemark.name = '';
      this.$refs.remarkRef.formDataRemark.dynamicText = '';
      this.dialogRemark =  true;
    },

    // 调用删除
    deleteLine(code) {
      this.$axios
        .post(api.deleteRemark, code)
        .then(res => {
          nSuccess("删除成功");
          this.pageNumRemark = 1;
          this.pageSizeRemark = 10;
          this.getRemarkList();
        })
        .catch(errorHandler("删除失败"));
    },
    changePaginationValue (data) {
      this.pageNumValue = data[0];
      this.pageSizeValue = data[1];
      this.getValueList();
    },
    changePaginationRemark (data) {
      this.pageNumRemark = data[0];
      this.pageSizeRemark = data[1];
      this.getRemarkList();
    },
  }
}
</script>

<style scoped>
form {
  width: 90%;
  margin: 0 auto;
  text-align: left;
}
.red {
  color: #FF0000;
  vertical-align: sub;
}
.form-line {
  margin: 20px 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.form-line>div {
  margin-right: 20px;
}
.line-text{
  color: #48576a;
  font-size: 14px;
  margin-right: 10px;
}
.textBox {
  display: inline-block;
  width: 190px;
  line-height: 32px;
  text-align: right;
}
.form-btn-box {
  width: 530px;
  padding: 0 110px 0 140px;
  margin: 40px 0 0 0;
  display: flex;
  justify-content: space-between;
}
.newly2 {
  display: inline-block;
  width: 250px;
  height: 173px;
  vertical-align: text-top;
  border: 1px dashed #D7D7D7;
  margin-right: 20px;
  position: relative;
}
.newly2 span {
  display: block;
  width: 100%;
  color: #999999;
  margin: 0;
  padding: 0;
  text-align: center;
}
.newly2 span:first-child {
  font-size: 36px;
  line-height: 120px;
  position: absolute;
  top: 15px;
}
.newly2 span:last-child {
  font-size: 14px;
  line-height: 50px;
  position: absolute;
  bottom: 0;
}
.upload2 {
  display: inline-block;
  width: 250px;
  height: 173px;
  vertical-align: text-top;
  background-size: 100% 100%;
  position: relative;
}

.upload2 img {
  width: 100%;
  height: 100%;
  border-radius: 5px;
}
.upload2 b {
  display: inline-block;
  width: 100%;
  line-height: 21px;
  color: white;
  background-color: #989796;
  text-align: center;
  position: absolute;
  bottom: 0;
  opacity: .7;
}
.btn-add {
  border: 0;
  color: #fff;
  padding: 8px 16px;
  background-color: #1362ff;
  font-size: 13px;
  height: 32px;
}
.btn-add:hover {
  color: #fff;
  background-color: #06b3ff;
}
</style>

<style lang="less" scoped>
.el-switch {
  height: 30px;
}
.el-input--small .el-input__inner {
  line-height: 30px;
}
/deep/.form-line {
  .el-date-editor .el-range-separator {
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Invoice/invoiceremarks/invoiceRemarksManage.vue